import { Download } from 'lucide-react';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { Pill } from '@/components/Pill';
import { Skeleton } from '@/components/Skeleton';
import * as shared from '../../tasks.css';
import type { ReportingTaskFile } from './types';

type InputFilesProps = {
    files: ReportingTaskFile[];
};

/**
 * The task's source-data files, each rendered as a downloadable pill.
 */
export function InputFiles({ files }: InputFilesProps) {
    return (
        <Flex direction="column" gap="2">
            <span className={shared.sectionLabel}>元データ</span>

            <Flex wrap="wrap" gap="2">
                {files.map((file) => (
                    <a key={file.downloadUrl} href={file.downloadUrl} download>
                        <Pill variant="quinary">
                            <Icon icon={Download} size="sm" />
                            {file.filename}
                        </Pill>
                    </a>
                ))}
            </Flex>
        </Flex>
    );
}

const SKELETON_FILE_COUNT = 3;

export function InputFilesSkeleton() {
    return (
        <Flex direction="column" gap="2">
            <span className={shared.sectionLabel}>元データ</span>

            <Flex wrap="wrap" gap="2">
                {Array.from({ length: SKELETON_FILE_COUNT }).map((_, i) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: loading placeholder, files have no identity
                    <Skeleton.Box key={i} width={140} height={32} />
                ))}
            </Flex>
        </Flex>
    );
}
